import * as CryptoJS from 'crypto-js';

// WARNING: Never hard-code your secret key directly in a production application.
// Use environment variables or a secure vault to manage it.
const secretKey = 'your-secret-key-that-is-at-least-32-characters-long';

/**
 * Custom hook to provide encryption and decryption functionality.
 * @returns An object containing the encrypt and decrypt functions.
 */
export const useEncryption = () => {
  /**
   * Encrypts a string using AES.
   * @param data The plaintext string to encrypt. 
   * @returns The encrypted string in a Base64 format.
   */
  const encrypt = (data) => {
    try {
      const encrypted = CryptoJS.AES.encrypt(data, secretKey).toString();
      return encrypted;
    } catch (e) {
      console.error("Encryption failed:", e);
      return null;
    }
  };

  /**
   * Decrypts an AES-encrypted string.
   * @param data The Base64-encoded encrypted string to decrypt.
   * @returns The decrypted plaintext string.
   */
  const decrypt = (data) => {
    try {
      const bytes = CryptoJS.AES.decrypt(data, secretKey);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);
      return decrypted;
    } catch (e) {
      console.error("Decryption failed:", e);
      return null;
    }
  };

  return { encrypt, decrypt };
};
